import { IconProps } from "./";
import Icon from "./assets/warning_44.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon44Warning(props: IconProps) {
  return <BaseIcon className="text-6xl" icon={<Icon />} {...props} />;
}
